import { BaseIcon, BaseIconProps } from '../BaseIcon';
import styles from './styles.scss';
import { joinClassNames } from '../../../../utils';

// Replace these HTMLAttributes with your correct one
type ClockIconProps = Omit<BaseIconProps, 'children'>;

export const ClockIcon = ({ className, ...props }: ClockIconProps) => (
  <BaseIcon
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={joinClassNames(styles.clockIcon, className)}
    {...props}
  >
    <path
      d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497"
      stroke="#141B4D"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line x1="12" y1="8" x2="12" y2="12" stroke="#141B4D" strokeWidth="2" strokeLinecap="round" />
    <line
      x1="14.5858"
      y1="14.5859"
      x2="12"
      y2="12.0002"
      stroke="#141B4D"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.766 5.15086C13.9786 4.64113 14.5641 4.40025 15.0739 4.61283C15.1053 4.62595 15.1367 4.63926 15.1679 4.65276C15.6749 4.87185 15.9083 5.46043 15.6892 5.96741C15.4701 6.47438 14.8815 6.70776 14.3745 6.48867C14.3511 6.47854 14.3276 6.46856 14.304 6.45873C13.7943 6.24615 13.5534 5.66059 13.766 5.15086ZM16.9525 6.9527C17.3908 6.61674 18.0185 6.69974 18.3545 7.13808C18.3752 7.16511 18.3958 7.19227 18.4161 7.21958C18.7465 7.66218 18.6555 8.28877 18.2128 8.6191C17.7702 8.94943 17.1437 8.85842 16.8133 8.41581C16.798 8.39534 16.7826 8.37497 16.7671 8.35471C16.4311 7.91636 16.5141 7.28866 16.9525 6.9527ZM18.8125 10.1049C19.3602 10.0337 19.8619 10.4199 19.9331 10.9676L19.9396 11.0184L19.9457 11.0693C20.01 11.6178 19.6175 12.1146 19.069 12.1789C18.5204 12.2432 18.0236 11.8507 17.9593 11.3022L17.9547 11.2638L17.9498 11.2255C17.8786 10.6778 18.2649 10.1761 18.8125 10.1049ZM18.8492 13.766C19.3589 13.9786 19.5998 14.5641 19.3872 15.0739C19.3741 15.1053 19.3608 15.1367 19.3473 15.1679C19.1282 15.6749 18.5396 15.9083 18.0327 15.6892C17.5257 15.4701 17.2923 14.8815 17.5114 14.3746C17.5215 14.3511 17.5315 14.3276 17.5413 14.304C17.7539 13.7943 18.3395 13.5534 18.8492 13.766Z"
      fill="#141B4D"
    />
  </BaseIcon>
);

ClockIcon.displayName = 'ClockIcon';
